<template>
  <div>
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="logo">
              <a title="PrintBox印箱" href=""><i class="icon-logo"></i></a>
            </div>
          </div>
          <div class="col-lg-9">
            <ul class="nav header-nav fr fs16 animate">
              <li class="">
                <a href="/print" class="router-link-active">打印</a>
              </li>
              <li class="">
                <a href="/download" class="">下载客户端</a>
              </li>
              <li v-if="!isLogin" >
                <a href="javascript:;" class="" @click="login">登录</a>
              </li>
              <li v-if="isLogin">
                <a href="/user" class="">个人中心</a>
              </li>
              <li v-if="isLogin">
                <a href="javascript:;" class="" @click="loginOut">退出</a>
              </li>
            </ul>


          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <!--<page-index/>-->
      <!--<page-print-setting/>-->
      <!--<page-print-map/>-->
      <!--<page-user/>-->
      <!--<page-download/>-->
      <router-view :isLogin="isLogin"/>
    </div>
    <div class="footer">
      <div class="container">
        <div class="fl footer-btn-group">
          <a class="footer-wechat"><i class="icon-wechat"></i>
            <div class="footer-tip footer-printbox"><i class="icon-corner"></i> <img src="./assets/img/printbox.png"></div>
          </a>
          <a class="footer-phone"><i class="icon-phone"></i>
            <div class="footer-tip"><i class="icon-corner"></i> 18630318929
            </div>
          </a>
          <a href="mailto://service@shareprint.club" class="footer-email"><i class="icon-email"></i>
            <div class="footer-tip"><i class="icon-corner"></i> service@shareprint.club
            </div>
          </a>
        </div>
        <div class="fr">印箱云打印</div>
       <a href="ys" class="fr" style="margin-right:20px">隐私政策</a>
      </div>
        
    </div>

    <modal-login @login="loginIn"/>

  </div>
</template>

<script>
  import {showModal, hideModal, ajax} from '@/api/global'
  import Cookies from 'js-cookie'

  import PageIndex from '@/pages/PageIndex'
  import PagePrintSetting from '@/pages/PagePrintSetting'
  import PagePrintMap from '@/pages/PagePrintMap'
  import PageUser from '@/pages/PageUser'
  import PageDownload from '@/pages/PageDownload'
  import ModalLogin from "@/components/ModalLogin"

  export default {
    name: "Layout",
    components: {
      ModalLogin,
      PageIndex,
      PagePrintSetting,
      PagePrintMap,
      PageUser,
      PageDownload,
    },
    data() {
      return {
        isLogin: false,
        // userInfo: {},
        path: '',
        token: '',
        // uid: '',
        // utype: '',
        conf: {
          service : {}
        },
        errorInfo: '',          // 系统错误信息
        uploadType: '',
        isUploading: false
      }

    },
    methods: {

      login : function () {
        showModal('login');
      },
      loginIn : function (token) {
        console.log('is login.................');
        this.isLogin = true;
        this.token = token;
        Cookies.set('token', token);
        hideModal('login');
        location.reload();
      },
      loginOut : function () {
        ajax({
          url : 'api/auth/jwt/invalid',
          type : 'post',
          data : {
            token : Cookies.get('token')
          },
          success : function (res) {
            console.log(res.data);
          },
          fail : function (res) {
            // self.errorMsg = res.message;
          }
        });


        this.isLogin = false;
        this.token = null;
        Cookies.set('token', '');
        this.$router.push('/')
      },
      checkPath : function () {
        for (var i = 0; i < arguments.length; i++) {
          if (router.currentRoute.path == '/' + arguments[i]) {
            return true;
          }
        }
        return false;
      },
      // ajaxConf : function () {
      //   var self = this;
      //   ajax({
      //     url : 'api/conf/app',
      //     type : 'get',
      //     success : function (res) {
      //       self.conf = res.data;
      //       for(var i = 0, length = self.conf.other.length; i < length; i++) {
      //         if (self.conf.other[i].key == 'service.email') {
      //           self.conf.service.email = self.conf.other[i].value;
      //           break;
      //         }
      //       }
      //     }
      //   });
      // },
    },
    created: function () {
      // this.ajaxConf();
      this.token = Cookies.get('token');
      console.info('token : ' + this.token);
      if (this.token) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
        // this.$router.push('/');       // 未登录跳转到首页
      }
    },
    mounted: function () {

    }
  }
</script>

<style>
  @import "assets/css/style.css";
  /*@import "../assets/fonts/iconfont.css";*/

</style>



// WEBPACK FOOTER //
// src/Layout.vue